import React from "react";
import { MenuItemEntity } from "../../../graphql/generated/graphql";
import { notEmpty } from "../../../utils/notEmpty";

import { ComponentRenderer } from "../../ComponentRenderer";
import { TextLink } from "../../navigation/TextLink";

interface IMainNavigationItem {
  item: MenuItemEntity;
}

export function NavbarMobileItem({ item }: IMainNavigationItem): JSX.Element {
  if (
    !item.attributes?.components ||
    item.attributes?.components.length === 0
  ) {
    return (
      <button className="text-base">
        <TextLink
          href={item.attributes?.page?.data?.attributes?.path || "#"}
          text={item.attributes?.label}
          className="font-bold"
        />
      </button>
    );
  }
  return (
    <div>
      <button className="text-base">
        <TextLink
          href={item.attributes?.page?.data?.attributes?.path || "#"}
          text={item.attributes?.label}
          className="font-bold"
        />
      </button>
      <div className="pl-2">
        <ComponentRenderer
          components={item.attributes?.components?.filter(notEmpty) || []}
        />
      </div>
    </div>
  );
}
